<template>
    <Banner :image="require('@/assets/images/banners/singlecourse.jpg')">
        <BannerCourseInfo v-if="!course.isMicrolearning" :course="course" />
        <BannerMicroLearningInfo v-else :course="course" />

        <TotemCourseInfo
            :categories="course.categoriesWithAncestors"
            :level="course.level"
            :certs="course.certifiedBy"
            :isLive="isLive(course)"
            :liveEventDate="getLiveEventDate(course)"
            :liveEventTime="getLiveEventTime(course)"
            :authorizationId="course.authorizationId"
            :durations="course.durations"
            :certifiedBy="course.certifiedBy"
            :title="course.title"
            :course="course"
            theme="highlight"
        />
    </Banner>
</template>

<script>
    import Banner from 'components/layout/Banner'
    import BannerCourseInfo from './BannerCourseInfo'
    import BannerMicroLearningInfo from './BannerMicroLearningInfo'

    import { mapGetters } from 'vuex'

    export default {
        components: {
            Banner,
            BannerCourseInfo,
            BannerMicroLearningInfo
        },
        props: {
            course: Object,
        },
        data () {
            return {
                courseToNewWatchlist: null,
            }
        },
        computed: {
            ...mapGetters({
                isLive: 'Courses/isLive',
                getLiveEventDate: 'Courses/getLiveEventDate',
                getLiveEventTime: 'Courses/getLiveEventTime'
            }),
        }
    }
</script>
